import { render, staticRenderFns } from "./DispatchToSelectItemFrom.vue?vue&type=template&id=21b5654e&scoped=true&"
import script from "./DispatchToSelectItemFrom.vue?vue&type=script&lang=js&"
export * from "./DispatchToSelectItemFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5654e",
  null
  
)

export default component.exports